import React from 'react';

interface IOwnProps {
    modifierClass?: string;
}

type Props = IOwnProps;

class Arrow extends React.Component<Props, {}> {
    public render() {
        return (
            <span className={"arrow " + this.props.modifierClass}>
                <svg viewBox="0 0 34 34" xmlns="http://www.w3.org/2000/svg">
                    <g fillRule="evenodd">
                        <path className="fill" d="M34 17c0 9.405-7.595 17-17 17-9.366 0-17-7.595-17-17C0 7.595 7.634 0 17 0c9.405 0 17 7.595 17 17zm-8.343 1.023c.315-.315.433-.708.433-1.023 0-.394-.118-.708-.433-1.023l-7.988-7.28c-.12-.158-.473-.354-.827-.354-.71 0-1.338.63-1.338 1.298 0 .277.078.67.393.946l5.746 5.076H9.05c-.668 0-1.298.63-1.298 1.338 0 .708.63 1.26 1.3 1.26h12.592l-5.746 5.154c-.315.236-.393.63-.393.945 0 .668.63 1.297 1.338 1.297.393 0 .747-.236.944-.393l7.87-7.24z" />
                        <path className="border" d="M34 17c0-9.405-7.595-17-17-17C7.634 0 0 7.595 0 17c0 9.405 7.634 17 17 17 9.405 0 17-7.595 17-17zm-2.715 0c0 7.87-6.375 14.245-14.285 14.245C9.13 31.245 2.794 24.87 2.794 17 2.794 9.13 9.13 2.794 17 2.794c7.91 0 14.285 6.336 14.285 14.206z" />
                        <path className="arrow-shape" d="M25.657 18.023c.315-.315.433-.708.433-1.023 0-.394-.118-.708-.433-1.023l-7.988-7.28c-.12-.158-.473-.354-.827-.354-.71 0-1.338.63-1.338 1.298 0 .277.078.67.393.946l5.746 5.076H9.05c-.668 0-1.298.63-1.298 1.338 0 .708.63 1.26 1.3 1.26h12.592l-5.746 5.154c-.315.236-.393.63-.393.945 0 .668.63 1.297 1.338 1.297.393 0 .747-.236.944-.393l7.87-7.24z" />
                    </g>
                </svg>
            </span>
        )
    }
}

export default Arrow;